import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import ConversationItem from '../../Inbox/ConversationItem';
import { getActiveConversations } from '../../../firebase/conversation.service';

const RecentInbox = ({ maxItems = 4 }) => {
    const { user, loading: authLoading } = useAuth();
    const [conversations, setConversations] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        let mounted = true;
        const fetch = async () => {
            if (!user?.uid || authLoading) return;
            setLoading(true);
            try {
                const data = await getActiveConversations(user.uid);
                if (!mounted) return;
                setConversations(data.slice(0, maxItems));
            } catch (err) {
                console.error('RecentInbox: failed to load conversations', err);
                if (!mounted) return;
                setConversations([]);
            } finally {
                if (mounted) setLoading(false);
            }
        };

        fetch();

        return () => { mounted = false; };
    }, [user?.uid, authLoading, maxItems]);

    const openConversation = (id) => {
        // Navigate to Inbox and request the conversation to open via location state
        navigate('/inbox', { state: { openConversationId: id } });
    };

    return (
        <div className="col-span-12 lg:col-span-7">
            <div className="flex items-center justify-between mb-4">
                <h2 className="text-base font-medium text-notion-text">Recent Inbox</h2>
                <button
                    onClick={() => navigate('/inbox')}
                    className="text-xs text-notion-text-light hover:text-stone-600"
                >
                    View All
                </button>
            </div>

            <div className="border border-notion-border rounded-lg overflow-hidden">
                {loading ? (
                    // Simple loading state
                    <div className="p-4">
                        <p className="text-sm text-notion-text-light">Loading recent messages...</p>
                    </div>
                ) : conversations.length === 0 ? (
                    <div className="p-6 text-center">
                        <p className="text-sm text-notion-text-light">No recent conversations</p>
                    </div>
                ) : (
                    <div className="max-h-[320px] overflow-y-auto">
                        {conversations.map((c, idx) => (
                            <ConversationItem
                                key={c.id}
                                conversation={c}
                                isActive={false}
                                onClick={() => openConversation(c.id)}
                            />
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default RecentInbox;
